module.exports = __webpack_public_path__ + "img/avatar-64.0bedf9f3.png";